export const environment = {
    production: true,
    token_storage: 'vna-lgw-token',
    api_url: 'https://api.aldaniti.net/api_bo/',
    nodejs_url: 'wss://lgnode.freemediainternet.com:9090',
    login_page: 'pages/login'
};



// WEBPACK FOOTER //
// /var/www/backend/src/environments/environment.ts